angular.module("cpm").directive("slider", function($window) {
	return {
		restrict: "E",
		template: "<div class='slider'></div><div class='slider-val'></div>",
		scope: {
			value: "=ngModel",
			min: "@",
			max: "@",
			step: "@?"
		},
		link: function($scope, $element) {
            let value = !!$scope.value ? parseFloat($scope.value) * 100 : parseFloat($scope.min) * 100;

			$(".slider", $element).slider({
				min: parseFloat($scope.min) * 100,
				max: parseFloat($scope.max) * 100,
				step: parseFloat($scope.step || 1),
				value: value,
				slide: function(ev, ui) {
					$scope.value = ui.value / 100;
					$(".slider-val", $element).text(($scope.value).toFixed(2));
				},
				slide: function(ev, ui) {
					if("undefined" !== typeof ev.originalEvent) { // don't fire from recalculate()
						$scope.value = ui.value / 100;
						$(".slider-val", $element).text(($scope.value).toFixed(2));
						$scope.$apply();
					}
				},
				change: function(ev, ui) {
					if("undefined" !== typeof ev.originalEvent) { // don't fire from recalculate()
						$scope.value = ui.value / 100;
						$(".slider-val", $element).text(($scope.value).toFixed(2));
						$scope.$apply();
					}
				}
			});
			
			$scope.$watch("value", function() {
				if(!!$scope.value) {
					$(".slider", $element).slider("value", $scope.value * 100);
					$(".slider-val", $element).text(parseFloat($scope.value).toFixed(2));
				}
			});
						
		}
	};
});